import { createReducer } from '@reduxjs/toolkit';
import { Reducer } from 'redux';

import { AuthActions, AuthState, isLoggedInSet, userNameSet } from './auth.actions';

const initialState: AuthState = { isLoggedIn: false, userName: '' };

export const AuthReducer: Reducer<AuthState, AuthActions> = createReducer(initialState, (builder) => {
    builder
        .addCase(isLoggedInSet, (state: AuthState, action: ReturnType<typeof isLoggedInSet>) =>
            Object.assign<object, AuthState, Partial<AuthState>>({}, state, { isLoggedIn: action.payload }),
        )
        .addCase(userNameSet, (state: AuthState, action: ReturnType<typeof userNameSet>) =>
            Object.assign<object, AuthState, Partial<AuthState>>({}, state, { userName: action.payload }),
        );
});
